export const SkipLinks = () => (
    <div className="skip-links" tabIndex="-1">
        <ul className="skip-links-inner">
            <li>
                <a id="skiplink-main-menu" href="#main-menu" title="Zum Hauptmenü springen">Hauptmenü</a>
            </li>
            <li>
                <a href="#main-content" title="Zum Inhalt springen">Inhaltsbereich</a>
            </li>
            <li>
                <a href="#footer-content" title="Zur Fußzeile springen">Fußzeile</a>
            </li>
        </ul>
    </div>
);
